import React from 'react'
import './worker_compensation.scss'
import { Hero, MainHeading, Breadcrumb, OneBlueCard, FindAgent, CommonTabs, NewsCard, SuccessStories, SentryCard, BussinessForm, Plans } from '../../../components';
import { images } from "../../../utils/customFn";
import { Container } from 'react-bootstrap';
const WorkerCompensation = () => {
    const breadcrumbs = [
        { label: "Sentry Insurance home", link: "/" },
        { label: "What we offer", link: "/what-we-offer" },
        { label: "Insurance products", link: "what-we-offer/insurance-products" },
        { label: "Workers Compesation", link: "what-we-offer/insurance-products/workers-compesation" },
    ];

    const activeTabId = "difference";

    const tabsData = [
        {
            id: "difference",
            href: "#/",
            label: "The Sentry difference",
        },
        {
            id: "policy",
            href: "#/",
            label: "Our workers’ compensation policy options",
        },
        {
            id: "help",
            href: "#/",
            label: "Who we've helped",
        },
    ];
    const sectrydata = {
        banner: images['two_workers_in_safety_gear_on_jobsite.avif'],
        heading: 'The Sentry difference',
        subheading: 'Custom workers’ compensation programs',
        para: 'We offer multiple loss-sensitive workers’ compensation program options. Along with traditional monthly paid loss programs, you can choose from monthly incurred loss programs, prefunded plans, retrospective rating insurance, and other hybrid types of insurance plans. Your business and your employees deserve a plan that protects them both.',
        sideheading: 'An accessible claims team you can trust',
        sidepara: 'With more than 1,000 claims team members countrywide, we process claims efficiently and fairly.',
        sideImg: images['gearsblue.svg']
    }
    const NewsCardData = [
        {
            id: 1,
            title: 'Large deductible workers’ compensation plan',
            description:
                'We have the 401(k) and other retirement plan options and services to help you and your employees plan for retirement.',
            linkUrl: '',
            linkText: 'More about 401(k) plans >',
        },
        {
            id: 2,
            title: 'Workers’ compensation small deductible plan',
            description:
                'We’ll work together to help you plan for the future.',
            linkUrl: '/',
            linkText: 'More about 401(k) plans and life insurance >',
        },
        {
            id: 3,
            title: 'Builder’s risk insurance',
            description:
                'Protect your profits and property from the unexpected during a construction or renovation project.',
            linkUrl: '/',
            linkText: 'More about builders risk insurance >',
        },
        {
            id: 4,
            title: 'Building insurance',
            description:
                'With our building property coverage policies, you and your business are protected in case your building is damaged and requires repair or rebuilding.',
            linkUrl: '',
            linkText: 'More about building insurance >',
        },
        {
            id: 5,
            title: 'Business auto insurance',
            description:
                'If driving is an important part of your business, we are ready to help you determine the most appropriate commercial auto coverages for your company.',
            linkUrl: '/',
            linkText: 'More about business auto insurance >',
        },
        {
            id: 6,
            title: 'Business income insurance',
            description:
                'Property damage shouldn’t result in lost income. With our business income solutions, we’ll help you get back to business as you recover from property damage.',
            linkUrl: '/',
            linkText: 'More about business income insurance >',
        },
    ];
    const letstalkData = {
        heading1: '',
        para1: 'Purchasing workers’ compensation insurance is legally required for businesses to be compliant in most states. But at Sentry, we see it as more than just a task. Protecting your employees after illness or injury is important, as is protecting your business from litigation. We’re knowledgeable when it comes to workers’ compensation for small, midsize, and large businesses, and we’ll help you manage your total cost of risk.',
        para2: 'How? By designing custom plans with your business in mind. By handling your workers’ compensation claims efficiently and promptly. And by evaluating medical bills and fees to help keep your costs down. Let’s meet today to discuss what your business needs.',
        para3: 'Are you a national accounts broker or part of a large corporation looking for loss-sensitive program options? We offer specialized services for',
        liks: ' national accounts and brokers.',
        blue_card_heading: 'Want to learn more about our workers’ comp programs?',
        blue_card_para: 'We’ll work with you to build a workers’ compensation insurance plan that makes sense for you and your employees.',
        button_text: "Let's talk"
    }
    const plansData = {
        blue_heading: 'Flexible coverage plans for large businesses',
        blue_para: 'These days, large, financially strong businesses often choose to finance much of their own workers’ compensation risk. Our large deductible and self-insurance plans provide structure to support those choices and situations.',
        purple_icon: images['Icon_of_two_purple_cups.svg'],
        purple_heading: 'Creating a culture of workplace safety',
        purple_para: "By creating a safer workplace environment for your employees, you can reduce the risk factors that contribute to workers’ compensation claims.Our safety services team has the resources and experience to help you reach that goal.",
    }
    return (
        <>
            {/* hero section */}
            <div className='workers_compensation'>
                <Hero img={images["group_of_factory_workers_together.avif"]} />
                <Container>
                    {/* Breadcrumb */}
                    <Breadcrumb crumbs={breadcrumbs} />

                    {/* heading  */}
                    <MainHeading title="Workers’ compensation" showshare={false} />

                    {/* Tabs */}
                    <CommonTabs tabs={tabsData} activeTab={activeTabId} />

                    {/* Layout */}
                    <OneBlueCard data={letstalkData} />

                    {/* the sentry card */}
                    <SentryCard data={sectrydata} />

                    {/* Plans section */}
                    <Plans data={plansData} />

                    {/* news card section */}
                    <NewsCard Title="Our workers’ compensation policy options" CardData={NewsCardData} showNavLink={false} subTitle="PRODUCTS" />

                    {/* sucess stories */}
                    <SuccessStories showSeemore={true} />

                    {/* news and resources */}
                    <NewsCard Title="News and resources" CardData={NewsCardData} showNavLink={false} subTitle="GUIDES" />

                    {/* bussiness form */}
                    <BussinessForm />

                    {/* find agent */}
                    <FindAgent />
                </Container>
            </div>
        </>
    )
}

export default WorkerCompensation